import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import CurrencyPriceList from 'components/PolicyPlans/Fields/CurrencyPriceList';
import { TextField } from '../../../ui/FormElement';
import { usePolicyPlanCustomRecordTemplateContext } from '../../../contexts/PolicyPlanCustomRecordTemplateContext';

function PriceField({ typeView, currency }) {
  const {
    values: { name },
    touched,
    setFieldValue,
  } = useFormikContext();

  const { state } = usePolicyPlanCustomRecordTemplateContext();
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    if (name != null) {
      const template = state.templates.find((item) => item.attributes.id === name);
      setSelectedTemplate(template);
      if (template != null) {
        setFieldValue('price', template.attributes.currency_prices.find((item) => item.currency === currency)?.price);
      }
    }
  }, [name, touched.name]);

  return (
    <>
      {typeView === 'policy' ? (
        <TextField
          name="price"
          label={(
            <>
              <span>Price Per Month</span>
              <abbr title="required">*</abbr>
            </>
          )}
        />
      ) : (
        <>
          {selectedTemplate && <CurrencyPriceList currencyPrices={selectedTemplate.attributes.currency_prices} />}
        </>
      )}
    </>
  );
}

export default PriceField;
